export default {"src":"/_next/static/media/arrow-right-icon.fda3bc10.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};